import { OrderRepository } from "../Repository/OrderRepository";


export interface UpdateOrderStatusUseCase {
  invoke: (data: any) => Promise<boolean>;
}

export class UpdateOrderStatus implements UpdateOrderStatusUseCase {
  private repo: OrderRepository;
  constructor(_Repo: OrderRepository) {
    this.repo = _Repo;
  }

   invoke(data: any){
    if(!data){
        throw new Error(
            "No tiene la data necesaria."
          );
    }
    const getData = this.repo.updateOrderStatus(data);
    return getData;
  }
}